import { ROUTES } from "../components/shared/constant";
import { IRouteDetails } from "../common/App.interface";
import {
  Home,
  Dashboard,
  Apps,
  HelpPlusSupport,
  QueryAndIssues,
  Platform,
  Account,
  InboxPage,
  AnalyticsDashboardPage,
  CallAnalyticsDashboardPage,
  UtmAnalyticsDashboardPage,
  CampaignAttributionDashboardPage,
  SurveysPage,
  SurveyBuilderPage,
  SurveyDetailPage,
  SurveyPreviewPage,
  SurveyTemplatesPage,
  PublicSurveyPage,
  PublicAssessmentPage,
  SKYPOINTSIGNUP,
  InstancesParent,
  InstanceHistory,
  InstancesDetails,
  InstanceBackup,
  TenantsSettings,
  CreateTenant,
  LogsPage,
  CrmUserDirectoryPage,
  UserSetupRedirect,
  RoleManagementPage,
  ErrorPage,
  GeneralSettingsPage,
  AsaListPage,
  AsaEditPage,
  AsaLocationsPage,
  ChannelsPage,
  CallsPage,
  TrainingPage,
  LeadsPage,
  LeadDetailPage,
  ScheduledToursPage,
  CrmIntegrationsPage,
  CampaignsListPage,
  CampaignBuilderPage,
  AdCampaignsPage,
  ModalConfigsPage,
  EmbedScriptGeneratorPage,
  TourAvailabilityPage,
  StaffProfilesPage,
  SmsAlertSettingsPage,
  NotificationPreferencesPage,
  AlertBannersPage,
  VideosPage,
  FaqPage,
  AssessmentsListPage,
  DripCampaignListPage,
  DripCampaignDetailPage,
  DripCampaignEditorPage,
  ConfigurationsPage,
  CallManagementPage,
  CrmDayPlannerPage,
  CrmOverviewPage,
  CrmTodayPage,
  CrmFalloutPage,
  CrmSkyAgentPage,
  CrmSkyBrainPage,
  CrmAgentSkillsPage,
  CrmMcpConnectorsPage,
  CrmAgentDraftsPage,
  CrmLandingRedirect,
  CrmProspectsPage,
  CrmMessengerPage,
  CrmActivitiesPage,
  CrmPersonDetailPage,
  CrmResidentsPage,
  CrmResidentDetailPage,
  CrmReferrerPersonsPage,
  CrmOrganizationsPage,
  CrmOrganizationDetailPage,
  CrmReferrerPersonDetailPage,
  CrmOccupancyPage,
  CrmOccupancyBoardPage,
  CrmAdmissionsBoardPage,
  CrmOccupancyUnitsPage,
  CrmOccupancyWaitlistPage,
  CrmOccupancyTransitionsPage,
  CrmYardiResolutionPage,
  CrmOccupancyReportPage,
  CrmReportsHubPage,
  CrmReportPage,
  CrmReportBuilderPage,
  CrmReportSchedulesPage,
  CrmReportDistributionListsPage,
  CrmReportPackagesPage,
  CrmReportPackageEditorPage,
  CrmEventsPage,
  CrmEventDetailPage,
  CrmCommunityEventsPage,
  CrmCommunityEventCreateWizard,
  CrmCommunityEventDetailPage,
  CrmHealthDashboardPage,
  CrmLeadSourcesPage,
  CrmApiTokensPage,
  CrmApiTokenEditPage,
  CrmWebhooksPage,
  CrmWebhookEditPage,
  CrmGlobalSetupPage,
  CrmGlobalSetupRedirect,
  CrmPacksPage,
  CrmTerminologyPage,
  CrmCustomFieldsPage,
  CrmStagesEditorPage,
  CrmActivityResultsEditorPage,
  CrmActivityTypesEditorPage,
  CrmCloseReasonsPage,
  CrmCompetitorsPage,
  CrmAccountBusinessHoursPage,
  SettingsSetupPage,
  SettingsCloseReasonsPage,
  SettingsCompetitorsPage,
  SettingsStagesPage,
  SettingsLeadProfilePage,
  CrmMotivatorsEditorPage,
  CrmBarriersEditorPage,
  CrmCommitmentTypesEditorPage,
  CrmDiscoveryCoachSettingsPage,
  CrmMoveOutReasonsPage,
  CrmConcessionTypesPage,
  CrmLeadSourceGroupsPage,
  CrmCommunityGroupsPage,
  CrmStandupListsPage,
  CrmCareTypesEditorPage,
  CrmCommunitiesListPage,
  CrmCommunitySetupPage,
  CrmRelationshipsEditorPage,
  CrmCommunicationTemplatesPage,
  CrmMyProfilePage,
  GoalsSettingsPage,
  CrmSlaConfigPage,
  CrmScoringConfigPage,
  CrmDashboardLayoutsPage,
  CrmAnnouncementsPage,
  CrmDataExportPage,
  CrmBiFeedConfigPage,
  CrmDeliveryDestinationsPage,
  CrmDeliveryDestinationEditPage,
  CrmAiGovernancePage,
  CrmAccessLogPage,
  CrmAuditRetentionPage,
  CrmConsentEnforcementPage,
  CrmAutomationsPage,
  CrmClinicalSyncPage,
  CrmMarketingIntegrationsPage,
} from "./lazyComponents";

export interface CreateRoutesConfig {
  hideNewdashboard: boolean;
  setSessionDefault: (value: any) => void;
}

export function createAppRoutes(config: CreateRoutesConfig): IRouteDetails[] {
  const { hideNewdashboard, setSessionDefault } = config;

  return [
    {
      name: "OldDashboard",
      path: ROUTES.HOME,
      component: Home,
      isRealTimeDataOn: false,
      accessibilityConditions: [hideNewdashboard],
    },
    {
      name: "NewDashboard",
      path: ROUTES.HOME,
      component: Dashboard,
      isRealTimeDataOn: false,
      accessibilityConditions: [!hideNewdashboard],
    },
    {
      name: "Apps",
      path: ROUTES.APPS + ROUTES.QUERYPARAMS,
      component: Apps,
      isRealTimeDataOn: false,
    },
    {
      name: "HelpPlusSupport",
      path: ROUTES.HELPPLUSSUPPORT + ROUTES.QUERYPARAMS,
      component: HelpPlusSupport,
      isRealTimeDataOn: false,
    },
    {
      name: "QueryAndIssues",
      path: ROUTES.QUERYANDISSUES + ROUTES.QUERYPARAMS,
      component: QueryAndIssues,
      isRealTimeDataOn: false,
    },
    {
      name: "Platform",
      path: ROUTES.PLATFORM + ROUTES.QUERYPARAMS,
      component: Platform,
      isRealTimeDataOn: false,
      extraProps: {
        setSessionDefault: setSessionDefault,
      },
    },
    {
      name: "GeneralSettings",
      path: ROUTES.GENERAL_SETTINGS + ROUTES.QUERYPARAMS,
      component: GeneralSettingsPage,
      isRealTimeDataOn: false,
    },
    {
      name: "Account",
      isRealTimeDataOn: false,
      path: ROUTES.ACCOUNT + ROUTES.QUERYPARAMS,
      component: Account,
    },
    {
      name: "Inbox",
      isRealTimeDataOn: false,
      path: ROUTES.INBOX + ROUTES.QUERYPARAMS,
      component: InboxPage,
    },
    {
      name: "Analytics",
      isRealTimeDataOn: false,
      path: ROUTES.ANALYTICS + ROUTES.QUERYPARAMS,
      component: AnalyticsDashboardPage,
    },
    {
      name: "CallAnalytics",
      isRealTimeDataOn: false,
      path: ROUTES.CALL_ANALYTICS + ROUTES.QUERYPARAMS,
      component: CallAnalyticsDashboardPage,
    },
    {
      name: "UtmAnalytics",
      isRealTimeDataOn: false,
      path: ROUTES.UTM_ANALYTICS + ROUTES.QUERYPARAMS,
      component: UtmAnalyticsDashboardPage,
    },
    {
      name: "CampaignAttribution",
      isRealTimeDataOn: false,
      path: ROUTES.CAMPAIGN_ATTRIBUTION + ROUTES.QUERYPARAMS,
      component: CampaignAttributionDashboardPage,
    },
    {
      name: "ModalConfigs",
      isRealTimeDataOn: false,
      path: ROUTES.MODAL_CONFIGS + ROUTES.QUERYPARAMS,
      component: ModalConfigsPage,
    },
    {
      name: "EmbedScriptGenerator",
      isRealTimeDataOn: false,
      path: ROUTES.EMBED_SCRIPT + ROUTES.QUERYPARAMS,
      component: EmbedScriptGeneratorPage,
    },
    {
      name: "SurveyCreate",
      isRealTimeDataOn: false,
      path: ROUTES.SURVEY_CREATE + ROUTES.QUERYPARAMS,
      component: SurveyBuilderPage,
    },
    {
      name: "SurveyTemplates",
      isRealTimeDataOn: false,
      path: ROUTES.SURVEY_TEMPLATES + ROUTES.QUERYPARAMS,
      component: SurveyTemplatesPage,
    },
    {
      name: "SurveyEdit",
      isRealTimeDataOn: false,
      path: ROUTES.SURVEY_EDIT + ROUTES.QUERYPARAMS,
      component: SurveyBuilderPage,
    },
    {
      name: "SurveyPreview",
      isRealTimeDataOn: false,
      path: ROUTES.SURVEY_PREVIEW + ROUTES.QUERYPARAMS,
      component: SurveyPreviewPage,
    },
    {
      name: "SurveyDetail",
      isRealTimeDataOn: false,
      path: ROUTES.SURVEY_DETAIL + ROUTES.QUERYPARAMS,
      component: SurveyDetailPage,
    },
    {
      name: "Surveys",
      isRealTimeDataOn: false,
      path: ROUTES.SURVEYS + ROUTES.QUERYPARAMS,
      component: SurveysPage,
    },
    {
      name: "PublicSurvey",
      isRealTimeDataOn: false,
      path: ROUTES.PUBLIC_SURVEY,
      component: PublicSurveyPage,
    },
    {
      name: "PublicAssessment",
      isRealTimeDataOn: false,
      path: ROUTES.PUBLIC_ASSESSMENT,
      component: PublicAssessmentPage,
    },
    {
      path: ROUTES.ERRORPAGE + ROUTES.QUERYPARAMS,
      name: "ErrorPage",
      component: ErrorPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.SKYPOINTSIGNUP + ROUTES.QUERYPARAMS,
      name: "SKYPOINTSIGNUP",
      component: SKYPOINTSIGNUP,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.VIEWINSTANCES + ROUTES.QUERYPARAMS,
      name: "InstancesParent",
      component: InstancesParent,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.VIEWINSTANCEHISTORY + ROUTES.QUERYPARAMS,
      name: "InstanceHistory",
      component: InstanceHistory,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.VIEWINSTANCEDETAILS + ROUTES.QUERYPARAMS,
      name: "InstancesDetails",
      component: InstancesDetails,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.VIEWINSTANCEBACKUP + ROUTES.QUERYPARAMS,
      name: "InstanceBackup",
      component: InstanceBackup,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.TENANTSETIINGS + ROUTES.QUERYPARAMS,
      name: "TenantsSettings",
      component: TenantsSettings,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CREATETENANT + ROUTES.QUERYPARAMS,
      name: "CreateTenant",
      component: CreateTenant,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.LOGS + ROUTES.QUERYPARAMS,
      name: "Logs",
      component: LogsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.USERS + ROUTES.QUERYPARAMS,
      name: "Users",
      component: CrmUserDirectoryPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.USER_SETUP + ROUTES.QUERYPARAMS,
      name: "User Setup",
      component: UserSetupRedirect,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.ROLES + ROUTES.QUERYPARAMS,
      name: "Roles",
      component: RoleManagementPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.ASA_LOCATIONS,
      name: "AsaLocations",
      component: AsaLocationsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.ASA_DETAIL,
      name: "AsaDetail",
      component: AsaEditPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.ASA,
      name: "AsaList",
      component: AsaListPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CHANNELS + ROUTES.QUERYPARAMS,
      name: "Channels",
      component: ChannelsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CALL_LOGS + ROUTES.QUERYPARAMS,
      name: "Calls",
      component: CallsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.TRAINING + ROUTES.QUERYPARAMS,
      name: "Training",
      component: TrainingPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.LEADS + ROUTES.QUERYPARAMS,
      name: "Leads",
      component: LeadsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.LEAD_DETAIL + ROUTES.QUERYPARAMS,
      name: "LeadDetail",
      component: LeadDetailPage,
      isRealTimeDataOn: false,
    },
    // Sky CRM (/crm/*) — pack-gated via PackRouteGuard (wrapped in AppLayout
    // for paths starting "/crm/"). RBAC RouteGuard intentionally lets these
    // through (getRequiredNavId returns null for /crm/*).
    {
      // Bare /crm → Day Planner (Refinement 4). NO QUERYPARAMS suffix —
      // an exact "/crm" match only; a "/:instanceid?" tail would
      // greedily collide with /crm/persons etc. (Day-5 fragility rule).
      path: ROUTES.CRM_LANDING,
      name: "CrmLanding",
      component: CrmLandingRedirect,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_OVERVIEW + ROUTES.QUERYPARAMS,
      name: "CrmOverview",
      component: CrmOverviewPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_TODAY + ROUTES.QUERYPARAMS,
      name: "CrmToday",
      component: CrmTodayPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_FORECAST_FALLOUT + ROUTES.QUERYPARAMS,
      name: "CrmForecastFallout",
      component: CrmFalloutPage,
      isRealTimeDataOn: false,
    },
    {
      // skyAgent full-page surface. The sidebar item is dropped with a console
      // warning if this route does not resolve, so the manifest entry in
      // lib/packs/senior_living.ts and this route must land together.
      path: ROUTES.CRM_SKYAGENT + ROUTES.QUERYPARAMS,
      name: "CrmSkyAgent",
      component: CrmSkyAgentPage,
      isRealTimeDataOn: false,
    },
    {
      // skyBrain — the durable facts skyAgent recalls. Registered BEFORE nothing
      // in particular: the two paths differ on a literal segment, so order does
      // not matter here the way it would with a param route.
      path: ROUTES.CRM_SKYBRAIN + ROUTES.QUERYPARAMS,
      name: "CrmSkyBrain",
      component: CrmSkyBrainPage,
      isRealTimeDataOn: false,
    },
    {
      // Playbooks — the written guidance a person gives the agent. In the sidebar
      // too, gated on `crm_agent_skills`.
      path: ROUTES.CRM_AGENT_SKILLS + ROUTES.QUERYPARAMS,
      name: "CrmAgentSkills",
      component: CrmAgentSkillsPage,
      isRealTimeDataOn: false,
    },
    {
      // Connectors — the remote systems skyAgent can use. Reached from the
      // composer's "+" menu rather than the sidebar: registering a system is a
      // rare managerial act and does not earn a permanent nav slot beside the
      // daily pages, whereas connecting your own account happens in the composer.
      path: ROUTES.CRM_MCP_CONNECTORS + ROUTES.QUERYPARAMS,
      name: "CrmMcpConnectors",
      component: CrmMcpConnectorsPage,
      isRealTimeDataOn: false,
    },
    {
      // Drafts — things skyAgent wrote that nobody has sent. Reached from the
      // chat, where they are saved, and from a prospect's record.
      path: ROUTES.CRM_AGENT_DRAFTS + ROUTES.QUERYPARAMS,
      name: "CrmAgentDrafts",
      component: CrmAgentDraftsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_DAY_PLANNER + ROUTES.QUERYPARAMS,
      name: "CrmDayPlanner",
      component: CrmDayPlannerPage,
      isRealTimeDataOn: false,
    },
    {
      // NO QUERYPARAMS on a list that has a ":id" detail sibling. React Router
      // expands the optional "/:instanceid?" segment into a SECOND pattern
      // (/crm/persons/:instanceid), which scores IDENTICALLY to the detail's
      // /crm/persons/:personId for a cold 3-segment URL. The tie falls back to
      // declaration order, so the list — declared first — swallowed the record
      // id as an instance id and rendered the LIST. Instance comes from the
      // store + the ?instanceid= querystring, never the list's path.
      // Same rule as CRM_REPORTS below. Guarded by
      // src/routes/__tests__/crmDeepLinkRoutes.test.ts.
      path: ROUTES.CRM_PERSONS,
      name: "CrmProspects",
      component: CrmProspectsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_ACTIVITIES + ROUTES.QUERYPARAMS,
      name: "CrmActivities",
      component: CrmActivitiesPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_PERSON_DETAIL + ROUTES.QUERYPARAMS,
      name: "CrmPersonDetail",
      component: CrmPersonDetailPage,
      isRealTimeDataOn: false,
    },
    {
      // NO QUERYPARAMS — see the CRM_PERSONS note above (the optional
      // ":instanceid?" would tie with /crm/residents/:residentId and swallow
      // cold detail deep links).
      path: ROUTES.CRM_RESIDENTS,
      name: "CrmResidents",
      component: CrmResidentsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_RESIDENT_DETAIL + ROUTES.QUERYPARAMS,
      name: "CrmResidentDetail",
      component: CrmResidentDetailPage,
      isRealTimeDataOn: false,
    },
    // REF-10 teardown — the org-first referrer list/detail routes are RETIRED. The
    // referrer surface is now the person-first list/detail below (the org survives only
    // as a container/lookup via referrer_organization_id + the KEEP'd /crm/referrers API).
    {
      // NO QUERYPARAMS — see the CRM_PERSONS note above (the optional
      // ":instanceid?" would tie with /crm/referrer-persons/:id and swallow
      // cold detail deep links).
      path: ROUTES.CRM_REFERRER_PERSONS,
      name: "CrmReferrerPersons",
      component: CrmReferrerPersonsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_REFERRER_PERSON_DETAIL + ROUTES.QUERYPARAMS,
      name: "CrmReferrerPersonDetail",
      component: CrmReferrerPersonDetailPage,
      isRealTimeDataOn: false,
    },
    // REF-11a/b — the Organizations browse list + detail (over the kept org container).
    {
      // NO QUERYPARAMS — see the CRM_PERSONS note above (the optional
      // ":instanceid?" would tie with /crm/organizations/:id and swallow cold
      // detail deep links).
      path: ROUTES.CRM_ORGANIZATIONS,
      name: "CrmOrganizations",
      component: CrmOrganizationsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_ORGANIZATION_DETAIL + ROUTES.QUERYPARAMS,
      name: "CrmOrganizationDetail",
      component: CrmOrganizationDetailPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_OCCUPANCY + ROUTES.QUERYPARAMS,
      name: "CrmOccupancy",
      component: CrmOccupancyPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_OCCUPANCY_BOARD + ROUTES.QUERYPARAMS,
      name: "CrmOccupancyBoard",
      component: CrmOccupancyBoardPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_ADMISSIONS + ROUTES.QUERYPARAMS,
      name: "CrmAdmissionsBoard",
      component: CrmAdmissionsBoardPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_OCCUPANCY_UNITS + ROUTES.QUERYPARAMS,
      name: "CrmOccupancyUnits",
      component: CrmOccupancyUnitsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_OCCUPANCY_WAITLIST + ROUTES.QUERYPARAMS,
      name: "CrmOccupancyWaitlist",
      component: CrmOccupancyWaitlistPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_OCCUPANCY_TRANSITIONS + ROUTES.QUERYPARAMS,
      name: "CrmOccupancyTransitions",
      component: CrmOccupancyTransitionsPage,
      isRealTimeDataOn: false,
    },
    {
      // Yardi Resolution Center. Under Occupancy because that is where the
      // duplicate it prevents would otherwise appear, and where the reference
      // implementation puts it.
      path: ROUTES.CRM_YARDI_RESOLUTION + ROUTES.QUERYPARAMS,
      name: "CrmYardiResolution",
      component: CrmYardiResolutionPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_OCCUPANCY_REPORT + ROUTES.QUERYPARAMS,
      name: "CrmOccupancyReport",
      component: CrmOccupancyReportPage,
      isRealTimeDataOn: false,
    },
    {
      // G13 builder. Declared ahead of the ":reportId" detail for readability —
      // React Router ranks static segments above dynamic ones, so "builder"
      // cannot be swallowed as a report id regardless of order. Same rule as the
      // events "/new" route below. NO QUERYPARAMS here either (see next block).
      path: ROUTES.CRM_REPORT_BUILDER,
      name: "CrmReportBuilder",
      component: CrmReportBuilderPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_REPORT_BUILDER_EDIT,
      name: "CrmReportBuilderEdit",
      component: CrmReportBuilderPage,
      isRealTimeDataOn: false,
    },
    {
      // PLC W16 Inc-2 — the central schedules page. Static, so it beats the
      // ":reportId" detail below; no QUERYPARAMS (same reason as the detail).
      path: ROUTES.CRM_REPORT_SCHEDULES,
      name: "CrmReportSchedules",
      component: CrmReportSchedulesPage,
      isRealTimeDataOn: false,
    },
    {
      // PLC W16 Inc-3 — distribution lists. Static, so it beats the ":reportId"
      // detail below; no QUERYPARAMS (same reason as the detail).
      path: ROUTES.CRM_REPORT_DISTRIBUTION_LISTS,
      name: "CrmReportDistributionLists",
      component: CrmReportDistributionListsPage,
      isRealTimeDataOn: false,
    },
    {
      // PLC W16 Inc-4 — report packages and one package's editor. Static
      // "packages", so both beat the ":reportId" detail below; no QUERYPARAMS
      // (same reason as the detail).
      path: ROUTES.CRM_REPORT_PACKAGES,
      name: "CrmReportPackages",
      component: CrmReportPackagesPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_REPORT_PACKAGE_DETAIL,
      name: "CrmReportPackage",
      component: CrmReportPackageEditorPage,
      isRealTimeDataOn: false,
    },
    {
      // No QUERYPARAMS optional :instanceid? segment here: it would let the hub
      // path (/crm/reports/:instanceid?) greedily match /crm/reports/:reportId
      // and shadow the detail route. Instance comes from the store + ?instanceId
      // querystring, not the path, so exact paths are correct and unambiguous.
      path: ROUTES.CRM_REPORT_DETAIL,
      name: "CrmReport",
      component: CrmReportPage,
      isRealTimeDataOn: false,
    },
    {
      // PLC W1 drill-through. SAME component — ReportPage reads the pathname and
      // renders drill mode. No QUERYPARAMS (same reason as the detail above);
      // `/crm/reports/` is a record-id subtree (instanceId.ts), so the trailing
      // "drill" segment is never harvested as an instance id.
      path: ROUTES.CRM_REPORT_DRILL,
      name: "CrmReportDrill",
      component: CrmReportPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_REPORTS,
      name: "CrmReportsHub",
      component: CrmReportsHubPage,
      isRealTimeDataOn: false,
    },
    // The Advisor surface of the hub. SAME components: they call
    // `useReportSurface()`, which reads the pathname, so there is one
    // implementation and no prop to forget. The server filters what each
    // surface may see.
    {
      path: ROUTES.ADVISOR_REPORTS,
      name: "AdvisorReportsHub",
      component: CrmReportsHubPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.ADVISOR_REPORT_DETAIL,
      name: "AdvisorReport",
      component: CrmReportPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_EVENTS + ROUTES.QUERYPARAMS,
      name: "CrmEvents",
      component: CrmEventsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_EVENT_DETAIL + ROUTES.QUERYPARAMS,
      name: "CrmEventDetail",
      component: CrmEventDetailPage,
      isRealTimeDataOn: false,
    },
    {
      // NO QUERYPARAMS — see the CRM_PERSONS note above (the optional
      // ":instanceid?" would tie with /crm/community-events/:eventId and
      // swallow cold detail deep links).
      path: ROUTES.CRM_COMMUNITY_EVENTS,
      name: "CrmCommunityEvents",
      component: CrmCommunityEventsPage,
      isRealTimeDataOn: false,
    },
    {
      // Static "/new" must rank above the ":eventId" detail route (React Router
      // ranks static segments higher, so order here is not load-bearing).
      path: ROUTES.CRM_COMMUNITY_EVENT_NEW + ROUTES.QUERYPARAMS,
      name: "CrmCommunityEventNew",
      component: CrmCommunityEventCreateWizard,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_COMMUNITY_EVENT_DETAIL + ROUTES.QUERYPARAMS,
      name: "CrmCommunityEventDetail",
      component: CrmCommunityEventDetailPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_HEALTH + ROUTES.QUERYPARAMS,
      name: "CrmHealth",
      component: CrmHealthDashboardPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_MESSENGER + ROUTES.QUERYPARAMS,
      name: "CrmMessenger",
      component: CrmMessengerPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_SETUP + ROUTES.QUERYPARAMS,
      name: "CrmSetup",
      component: CrmGlobalSetupPage,
      isRealTimeDataOn: false,
    },
    // Legacy hub address. Redirects to /crm/setup with the instance segment and
    // every query param intact. Same /crm/* prefix as the destination, so
    // AppLayout wraps it in PackRouteGuard exactly like the page it forwards to.
    {
      path: ROUTES.CRM_GLOBAL_SETUP + ROUTES.QUERYPARAMS,
      name: "CrmGlobalSetupRedirect",
      component: CrmGlobalSetupRedirect,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_PACKS + ROUTES.QUERYPARAMS,
      name: "CrmPacks",
      component: CrmPacksPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_TERMINOLOGY + ROUTES.QUERYPARAMS,
      name: "CrmTerminology",
      component: CrmTerminologyPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_CUSTOM_FIELDS + ROUTES.QUERYPARAMS,
      name: "CrmCustomFields",
      component: CrmCustomFieldsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_STAGES + ROUTES.QUERYPARAMS,
      name: "CrmStagesEditor",
      component: CrmStagesEditorPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_ACTIVITY_RESULTS + ROUTES.QUERYPARAMS,
      name: "CrmActivityResultsEditor",
      component: CrmActivityResultsEditorPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_ACTIVITY_TYPES + ROUTES.QUERYPARAMS,
      name: "CrmActivityTypesEditor",
      component: CrmActivityTypesEditorPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_CARE_TYPES + ROUTES.QUERYPARAMS,
      name: "CrmCareTypesEditor",
      component: CrmCareTypesEditorPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_COMMUNITIES + ROUTES.QUERYPARAMS,
      name: "CrmCommunities",
      component: CrmCommunitiesListPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_COMMUNITY_SETUP + "/:communityId",
      name: "CrmCommunitySetup",
      component: CrmCommunitySetupPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_RELATIONSHIPS + ROUTES.QUERYPARAMS,
      name: "CrmRelationshipsEditor",
      component: CrmRelationshipsEditorPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_LEAD_SOURCES + ROUTES.QUERYPARAMS,
      name: "CrmLeadSources",
      component: CrmLeadSourcesPage,
      isRealTimeDataOn: false,
    },
    {
      // PLC W8 Inc-5 — lead-source groups (manageSettings page, shown only with
      // the senior-living `lead_source_taxonomy` feature; the server gates the
      // routes on the same feature).
      path: ROUTES.CRM_LEAD_SOURCE_GROUPS + ROUTES.QUERYPARAMS,
      name: "CrmLeadSourceGroups",
      component: CrmLeadSourceGroupsPage,
      isRealTimeDataOn: false,
    },
    {
      // PLC Section 1 Inc-4 — saved community groups (any CRM role reads; editing
      // needs manageSettings + a CRM manager/admin; shown only with the
      // senior-living `portfolio_overview` feature, which the server gates too).
      path: ROUTES.CRM_COMMUNITY_GROUPS + ROUTES.QUERYPARAMS,
      name: "CrmCommunityGroups",
      component: CrmCommunityGroupsPage,
      isRealTimeDataOn: false,
    },
    {
      // PLC W12 Inc-4 — stand-up distribution lists (CRM manager/admin; shown only
      // with the senior-living `standup_distribution` feature, which the server
      // gates too).
      path: ROUTES.CRM_STANDUP_LISTS + ROUTES.QUERYPARAMS,
      name: "CrmStandupLists",
      component: CrmStandupListsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_API_TOKENS + ROUTES.QUERYPARAMS,
      name: "CrmApiTokens",
      component: CrmApiTokensPage,
      isRealTimeDataOn: false,
    },
    {
      // tokenId = "new" mints; a uuid edits. The editor lives on the SINGULAR
      // path so it can never be read as the list route's :instanceid segment.
      path: ROUTES.CRM_API_TOKEN_EDIT + "/:tokenId",
      name: "CrmApiTokenEdit",
      component: CrmApiTokenEditPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_WEBHOOKS + ROUTES.QUERYPARAMS,
      name: "CrmWebhooks",
      component: CrmWebhooksPage,
      isRealTimeDataOn: false,
    },
    {
      // subscriptionId = "new" creates; a uuid edits. Same singular-path split
      // as the API token editor above.
      path: ROUTES.CRM_WEBHOOK_EDIT + "/:subscriptionId",
      name: "CrmWebhookEdit",
      component: CrmWebhookEditPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_CLOSE_REASONS + ROUTES.QUERYPARAMS,
      name: "CrmCloseReasons",
      component: CrmCloseReasonsPage,
      isRealTimeDataOn: false,
    },
    {
      // PLC W7 Inc-3 — the managed competitor list (manageSettings page; the
      // server gates the list on the close_reasons pack feature).
      path: ROUTES.CRM_COMPETITORS + ROUTES.QUERYPARAMS,
      name: "CrmCompetitors",
      component: CrmCompetitorsPage,
      isRealTimeDataOn: false,
    },
    {
      // R6 — the Advisor Setup hub. Tiles are defined in CODE, so reaching a new
      // configuration surface never again depends on a per-tenant
      // platform_config row carrying a child for it.
      path: ROUTES.SETTINGS_SETUP + ROUTES.QUERYPARAMS,
      name: "SettingsSetup",
      component: SettingsSetupPage,
      isRealTimeDataOn: false,
    },
    {
      // H3 Inc-2 — the Advisor Settings route for the SAME close-reason editor.
      // A distinct path (not under /crm) because Advisor-only tenants must reach
      // it; the component and the API slice are shared, so the two doors cannot
      // drift. Not a /crm list surface, so the QUERYPARAMS/detail-shadowing rule
      // that crmDeepLinkRoutes.test.ts polices does not apply here.
      path: ROUTES.SETTINGS_CLOSE_REASONS + ROUTES.QUERYPARAMS,
      name: "SettingsCloseReasons",
      component: SettingsCloseReasonsPage,
      isRealTimeDataOn: false,
    },
    {
      // PLC W7 Inc-3 — the Advisor door to the Competitors editor. RouteGuard
      // admits it exactly where it admits /settings/close-reasons (both map to
      // the CLOSE_REASONS nav id, routeMapping.ts); the page refuses without
      // manageSettings and the server enforces both gates (close_reasons pack
      // feature + manageSettings).
      path: ROUTES.SETTINGS_COMPETITORS + ROUTES.QUERYPARAMS,
      name: "SettingsCompetitors",
      component: SettingsCompetitorsPage,
      isRealTimeDataOn: false,
    },
    {
      // PACE (`pipeline_funnel`) — rename-only stage settings. Advisor-side for
      // the same reason as Close Reasons: an Advisor-only tenant must reach it.
      // The page itself refuses without manageSettings and skips its query
      // off-feature; the server 404s off-feature and 403s without the permission.
      path: ROUTES.SETTINGS_STAGES + ROUTES.QUERYPARAMS,
      name: "SettingsStages",
      component: SettingsStagesPage,
      isRealTimeDataOn: false,
    },
    {
      // vertical-lead-profile (D-4 / D-8 as amended) — GLOBAL-scope Skypoint admins
      // only. RouteGuard admits it where it admits /settings/setup (same nav id,
      // routeMapping.ts); the page refuses anyone without isPlatformAdmin and every
      // route behind it is requireSkypointAdmin.
      path: ROUTES.SETTINGS_LEAD_PROFILE + ROUTES.QUERYPARAMS,
      name: "SettingsLeadProfile",
      component: SettingsLeadProfilePage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_MOTIVATORS + ROUTES.QUERYPARAMS,
      name: "CrmMotivatorsEditor",
      component: CrmMotivatorsEditorPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_BARRIERS + ROUTES.QUERYPARAMS,
      name: "CrmBarriersEditor",
      component: CrmBarriersEditorPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_COMMITMENT_TYPES + ROUTES.QUERYPARAMS,
      name: "CrmCommitmentTypesEditor",
      component: CrmCommitmentTypesEditorPage,
      isRealTimeDataOn: false,
    },
    {
      // PLC W13 Inc-3 — Discovery Coach settings. The page refuses without
      // manageSettings, says "not available" without `coach_guidance` (and skips
      // its query), and enables Save only for a CRM admin; the server 404s
      // off-feature and 403s a non-admin PUT.
      path: ROUTES.CRM_DISCOVERY_COACHING + ROUTES.QUERYPARAMS,
      name: "CrmDiscoveryCoachSettings",
      component: CrmDiscoveryCoachSettingsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_MOVE_OUT_REASONS + ROUTES.QUERYPARAMS,
      name: "CrmMoveOutReasons",
      component: CrmMoveOutReasonsPage,
      isRealTimeDataOn: false,
    },
    {
      // PLC W9 Inc-2 — the managed concession type list (manageSettings page,
      // shown only with the senior-living `concessions` feature; the server
      // gates the list on the same feature).
      path: ROUTES.CRM_CONCESSION_TYPES + ROUTES.QUERYPARAMS,
      name: "CrmConcessionTypes",
      component: CrmConcessionTypesPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_COMMUNICATION_TEMPLATES + ROUTES.QUERYPARAMS,
      name: "CrmCommunicationTemplates",
      component: CrmCommunicationTemplatesPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_PROFILE + ROUTES.QUERYPARAMS,
      name: "CrmMyProfile",
      component: CrmMyProfilePage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_GOALS + ROUTES.QUERYPARAMS,
      name: "CrmGoals",
      component: GoalsSettingsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_SLA_CONFIG + ROUTES.QUERYPARAMS,
      name: "CrmSlaConfig",
      component: CrmSlaConfigPage,
      isRealTimeDataOn: false,
    },
    {
      // PLC W15 Inc-5 — the account default business hours (manageSettings page).
      path: ROUTES.CRM_BUSINESS_HOURS + ROUTES.QUERYPARAMS,
      name: "CrmBusinessHours",
      component: CrmAccountBusinessHoursPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_SCORING_CONFIG + ROUTES.QUERYPARAMS,
      name: "CrmScoringConfig",
      component: CrmScoringConfigPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_DASHBOARD_LAYOUTS + ROUTES.QUERYPARAMS,
      name: "CrmDashboardLayouts",
      component: CrmDashboardLayoutsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_ANNOUNCEMENTS + ROUTES.QUERYPARAMS,
      name: "CrmAnnouncements",
      component: CrmAnnouncementsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_DATA_EXPORT + ROUTES.QUERYPARAMS,
      name: "CrmDataExport",
      component: CrmDataExportPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_BI_FEED + ROUTES.QUERYPARAMS,
      name: "CrmBiFeed",
      component: CrmBiFeedConfigPage,
      isRealTimeDataOn: false,
    },
    // G18 — where completed artifacts get pushed. The list and the editor are
    // separate routes (the WebhooksPage/WebhookEditPage pair), because the
    // editor hosts the host-key trust flow and deserves its own URL.
    {
      path: ROUTES.CRM_DELIVERY_DESTINATIONS + ROUTES.QUERYPARAMS,
      name: "CrmDeliveryDestinations",
      component: CrmDeliveryDestinationsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_DELIVERY_DESTINATION_EDIT + "/:id" + ROUTES.QUERYPARAMS,
      name: "CrmDeliveryDestinationEdit",
      component: CrmDeliveryDestinationEditPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_AI_GOVERNANCE + ROUTES.QUERYPARAMS,
      name: "CrmAiGovernance",
      component: CrmAiGovernancePage,
      isRealTimeDataOn: false,
    },
    // [FT-REHOME-RETENTION] — audit retention's own address. Its predecessor
    // (/crm/settings/ai-governance?section=audit-retention) still resolves here;
    // the forwarding lives on the AI Governance route, not in this table.
    {
      path: ROUTES.CRM_AUDIT_RETENTION + ROUTES.QUERYPARAMS,
      name: "CrmAuditRetention",
      component: CrmAuditRetentionPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_ACCESS_LOG + ROUTES.QUERYPARAMS,
      name: "CrmAccessLog",
      component: CrmAccessLogPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_CONSENT_ENFORCEMENT + ROUTES.QUERYPARAMS,
      name: "CrmConsentEnforcement",
      component: CrmConsentEnforcementPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_AUTOMATIONS + ROUTES.QUERYPARAMS,
      name: "CrmAutomations",
      component: CrmAutomationsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_CLINICAL_SYNC + ROUTES.QUERYPARAMS,
      name: "CrmClinicalSync",
      component: CrmClinicalSyncPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_MARKETING_INTEGRATIONS + ROUTES.QUERYPARAMS,
      name: "CrmMarketingIntegrations",
      component: CrmMarketingIntegrationsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.SCHEDULED_TOURS + ROUTES.QUERYPARAMS,
      name: "ScheduledTours",
      component: ScheduledToursPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CRM_INTEGRATIONS + ROUTES.QUERYPARAMS,
      name: "CrmIntegrations",
      component: CrmIntegrationsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CAMPAIGNS + ROUTES.QUERYPARAMS,
      name: "Campaigns",
      component: CampaignsListPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CAMPAIGN_BUILDER + ROUTES.QUERYPARAMS,
      name: "CampaignBuilder",
      component: CampaignBuilderPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.AD_CAMPAIGNS + ROUTES.QUERYPARAMS,
      name: "AdCampaigns",
      component: AdCampaignsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.DRIP_CAMPAIGN_EDITOR + ROUTES.QUERYPARAMS,
      name: "DripCampaignEditor",
      component: DripCampaignEditorPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.DRIP_CAMPAIGN_DETAIL + ROUTES.QUERYPARAMS,
      name: "DripCampaignDetail",
      component: DripCampaignDetailPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.DRIP_CAMPAIGNS + ROUTES.QUERYPARAMS,
      name: "DripCampaigns",
      component: DripCampaignListPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CONFIGURATIONS + ROUTES.QUERYPARAMS,
      name: "Configurations",
      component: ConfigurationsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.TOUR_AVAILABILITY + ROUTES.QUERYPARAMS,
      name: "TourAvailability",
      component: TourAvailabilityPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.STAFF_PROFILES + ROUTES.QUERYPARAMS,
      name: "StaffProfiles",
      component: StaffProfilesPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.SMS_ALERT_SETTINGS + ROUTES.QUERYPARAMS,
      name: "SmsAlertSettings",
      component: SmsAlertSettingsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.NOTIFICATION_PREFERENCES + ROUTES.QUERYPARAMS,
      name: "NotificationPreferences",
      component: NotificationPreferencesPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CALL_MANAGEMENT + ROUTES.QUERYPARAMS,
      name: "CallManagement",
      component: CallManagementPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.ALERT_BANNERS + ROUTES.QUERYPARAMS,
      name: "AlertBanners",
      component: AlertBannersPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.VIDEOS + ROUTES.QUERYPARAMS,
      name: "Videos",
      component: VideosPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.FAQ + ROUTES.QUERYPARAMS,
      name: "Faq",
      component: FaqPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.ASSESSMENTS + ROUTES.QUERYPARAMS,
      name: "Assessments",
      component: AssessmentsListPage,
      isRealTimeDataOn: false,
    },
  ];
}
